import React from "react";
import { Stack, Skeleton, Grid } from "@mui/material";

const UserListSkeletonLoader = ({ count = 2 }) => {
  return (
    <>
      {Array.from(new Array(count)).map((_, mainIndex) => (
        <Stack key={mainIndex} gap={2} sx={{ p: 2, border: "1px solid #ddd", borderRadius: 2, mb: 2 }}>
          {/* User Profile Section */}
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Stack direction="row" alignItems="flex-start" spacing={2}>
              <Skeleton variant="circular" width={50} height={50} />
              <Stack>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Skeleton variant="text" width={100} />
                </Stack>
                <Skeleton variant="text" width={80} />
              </Stack>
            </Stack>
          </Stack>

          {/* Wheels Grid */}
          <Grid container spacing={2}>
            {Array.from(new Array(5)).map((_, index) => (
              <Grid item xs={12} sm={6} md={4} lg={2.4} xl={2.4} key={index}>
                <Skeleton sx={{ borderRadius: 2 }} variant="rectangular" width="100%" height={230} />
              </Grid>
            ))}
          </Grid>
        </Stack>
      ))}
    </>
  );
};

export default UserListSkeletonLoader;
